export default function ButtonBase(){
    return {
        styleOverrides: {
            paper: {
                borderRadius: 8
            }
        }
    }
}